import { useEffect, useState } from "react";
import AuthService from "../services/authentication/auth.service.ts";

let cachedRoles: string[] | null = null;

const useUserAccess = () => {
  const [roles, setRoles] = useState<string[]>([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isWellAdmin, setIsWellAdmin] = useState(false);

  useEffect(() => {
    const fetchRoles = async () => {
      if (cachedRoles) {
        setRoles(cachedRoles);
        setIsAdmin(cachedRoles.includes("admin"));
        setIsWellAdmin(cachedRoles.includes("wellAdmin"));
      } else {
        const fetchedRoles = await AuthService.getUserRoles();
        cachedRoles = fetchedRoles;
        setRoles(fetchedRoles);
        setIsAdmin(fetchedRoles.includes("admin"));
        setIsWellAdmin(fetchedRoles.includes("wellAdmin"));
      }
    };

    fetchRoles();
  }, []);

  return { roles, isAdmin, isWellAdmin };
};

export default useUserAccess;
